"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAndGetKeyValueConfig = exports.buildBannerLink = void 0;
const brand_provider_1 = require("../../providers/brand.provider");
const config_1 = require("../../utils/helpers/config");
function buildBannerLink(bannerConfig, catalogSlug) {
    const link = (bannerConfig === null || bannerConfig === void 0 ? void 0 : bannerConfig.link)
        ? bannerConfig.link
            .replace(new RegExp('{{catalogSlug}}', 'g'), catalogSlug)
            .replace(new RegExp('{{mldDomain}}', 'g'), brand_provider_1.BrandProvider.getBrandDomain())
        : '';
    if (!link)
        return null;
    const url = new URL(link);
    url.searchParams.set('origin', config_1.envConfig.currentBrand);
    url.searchParams.set('utm_source', config_1.envConfig.currentBrand);
    return url.toString();
}
exports.buildBannerLink = buildBannerLink;
function parseAndGetKeyValueConfig(jsonValue, { key, schema }) {
    try {
        const parsedValue = JSON.parse(jsonValue);
        if (!Object.keys(parsedValue).length) {
            return null;
        }
        const config = parsedValue[key] || parsedValue.default;
        if (!config) {
            return null;
        }
        const parsedConfig = schema.cast(config);
        return parsedConfig;
    }
    catch (e) {
        console.error('Error parsing config value:', e);
        return null;
    }
}
exports.parseAndGetKeyValueConfig = parseAndGetKeyValueConfig;
